import React, { useState, useEffect } from 'react';

const Version = () => {
  const [version, setVersion] = useState('dev');

  useEffect(() => {
    const fetchVersion = async () => {
      try {
        const API_BASE_URL = process.env.NODE_ENV === 'production' 
          ? window.location.origin 
          : 'http://localhost:3001';
        
        const response = await fetch(`${API_BASE_URL}/api/version`);
        
        if (response.ok) {
          const data = await response.json();
          setVersion(data.version);
        }
      } catch (error) {
        console.error('Failed to fetch version:', error);
        // Keep default 'dev' version on error
      }
    };

    fetchVersion();
  }, []);

  return (
    <div className="version-display">
      PlatePeek - {version}
    </div>
  );
};

export default Version;
